import { AxiosResponse } from "axios";

import { Page } from "../types/pagination.definition";

/** Header the BFF sets on paged list responses with the full count. */
export const TOTAL_COUNT_HEADER = "x-total-count";

/**
 * Reads a paged list response: the body is the page, the `X-Total-Count`
 * header the full count. Without the header the page is taken as the whole list.
 */
export function toPage<T>(response: AxiosResponse<T[]>): Page<T> {
  const items = response.data ?? [];
  const total = Number.parseInt(
    String(response.headers?.[TOTAL_COUNT_HEADER] ?? ""),
    10
  );
  return { items, total: Number.isNaN(total) ? items.length : total };
}
